import { formatUnits } from "ethers/lib/utils";
import { BigNumber } from "ethers";
import { PoolData, TimerData } from "types";

export function formatResult(res: BigNumber, dec: number = 18) {
  return parseFloat(formatUnits(res, dec));
}

const poolNames = {
  0: "YGY/RAM",
};

export function mapPoolInfoToClientDataObject(poolId: number, poolInfo: any, totalStaked: number, stakingTokenName: string): PoolData {
  return {
    poolId: poolId.toString(),
    name: poolNames[poolId],
    stakingTokenName,
    totalStaked,
    chainData: {
      token: poolInfo.token,
      allocPoint: Number(poolInfo.allocPoint),
      accRAMPerShare: Number(poolInfo.accRAMPerShare),
      accYGYPerShare: Number(poolInfo.accYGYPerShare),
      withdrawable: poolInfo.withdrawable,
      effectiveAdditionalTokensFromBoosts: Number(poolInfo.effectiveAdditionalTokensFromBoosts),
    },
  };
}

export function getTimeRemaining(endtime: any): TimerData {
  const total = endtime.getTime() - new Date().getTime();
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const seconds = Math.floor((total / 1000) % 60);

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  };
}

export function noExponents(number: number) {
  var data = String(number).split(/[eE]/);
  if (data.length === 1) return data[0];

  var z = "",
    sign = number < 0 ? "-" : "",
    str = data[0].replace(".", ""),
    mag = Number(data[1]) + 1;

  if (mag < 0) {
    z = sign + "0.";
    while (mag++) z += "0";
    return z + str.replace(/^-/, "");
  }
  mag -= str.length;
  while (mag--) z += "0";
  return str + z;
}

export function ensure<T>(argument: T | undefined | null, message: string = "This value was promised to be there."): T {
  if (argument === undefined || argument === null) {
    throw new TypeError(message);
  }

  return argument;
}
